import { forwardRef } from 'react'

import { IconProps, IconVariants } from '../IconVariants'
const CloseIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size, ...props }, ref) => {
  return (
    <svg
      aria-hidden="true"
      className={IconVariants({
        class: className,
        size,
      })}
      fill="none"
      height="1em"
      ref={ref}
      viewBox="0 0 24 24"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M11 12L4.99999 18L6.41421 19.4142L12.4142 13.4142L18 19L19.4142 17.5858L13.8284 12L19.1421 6.68628L17.7279 5.27207L12.4142 10.5858L6.6863 4.85786L5.27208 6.27207L11 12Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  )
})
CloseIcon.displayName = 'CloseIcon'
export default CloseIcon
